import { Controller } from '@hotwired/stimulus'
import { mandaPasoDeLaBaja } from 'lib/pasos_de_la_baja'

// Connects to data-controller="revision-de-newsletters".
//
// «Revisar mis newsletters» en la página de después de la baja (US-147-2.4.2,
// `suscribir_desuscribir/_revisar_newsletters.haml`). Sustituye, con el nuevo flujo de baja, a
// `suscripciones_controller`, que sigue en la página de la baja comercial. Lo que cambia:
//
// - «Guardar cambios» nunca está desactivado. Sin nada desmarcado, lo dice dentro de la página.
// - Quitarlas todas se confirma con un aviso dentro de la página y no con el `confirm()` del
//   navegador. El foco pasa a «Sí, dejar de recibirlas todas»; «Cancelar» lo devuelve a «Guardar».
// - Los textos de los avisos están en el HTML (`<template>`), no aquí.
export default class extends Controller {
  static targets = ['oferta', 'lista', 'titulo', 'formulario', 'aviso', 'guardar', 'nadaQueGuardar', 'todas', 'si']
  static values = { pasoUrl: String }

  abre () {
    this.ofertaTarget.hidden = true
    this.listaTarget.hidden = false
    this.tituloTarget.focus()
    mandaPasoDeLaBaja(this.pasoUrlValue)
  }

  cambia (event) {
    this.tacha(event.target)
    this.limpiaAviso()
  }

  desmarcaTodas () {
    this.casillas().forEach(casilla => {
      casilla.checked = false
      this.tacha(casilla)
    })
    this.limpiaAviso()
  }

  guarda (event) {
    if (this.confirmada) return

    const desmarcadas = this.casillas().filter(casilla => !casilla.checked).length
    if (desmarcadas === 0) {
      event.preventDefault()
      this.muestraAviso(this.nadaQueGuardarTarget)
    } else if (desmarcadas === this.casillas().length) {
      event.preventDefault()
      this.muestraAviso(this.todasTarget)
      this.siTarget.focus()
    }
  }

  confirmaTodas () {
    this.confirmada = true
    this.formularioTarget.requestSubmit(this.guardarTarget)
  }

  cancela () {
    this.limpiaAviso()
    this.guardarTarget.focus()
  }

  // privados

  casillas () {
    return Array.from(this.formularioTarget.querySelectorAll('input[type="checkbox"]'))
  }

  tacha (casilla) {
    const nombre = casilla.closest('label').querySelector('span')
    nombre.classList.toggle('rnk-text-decoration-line-through', !casilla.checked)
  }

  muestraAviso (plantilla) {
    this.avisoTarget.replaceChildren(plantilla.content.cloneNode(true))
  }

  limpiaAviso () {
    this.avisoTarget.replaceChildren()
  }
}
